import { site } from "../api/url_helper";

export const downloadFile = (fileUrl) => {
    window.open(site + "/" + fileUrl, "_blank");
};
